<template>
    <div class="content">
        <div class="title-body">
            <!--{{ product.product_name }} -->
        </div>
        <div class="but-body">
            <el-button type="primary" @click="redirectToExternalLink" class="el-but1">
                进入体验
            </el-button>
            <el-button type="primary" class="el-but1" @click="playVideo" v-show="product.product_video != null && product.product_video != ''">观看介绍</el-button>
            <div v-if="videoVisible" class="video-container">
                <video controls width="100%" height="auto">
                    <source :src="product.product_video" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
                <el-button @click="closeVideo">关闭视频</el-button>
            </div>

        </div>
        <div class="img-body">
            <div v-for="(item, index) in imgList" :key="index" class="content-img"
                :style="{ backgroundImage: `url(${item.imgurl})` }">
                <!-- 其他内容 -->
            </div>
        </div>
        <div class="co-body" v-show="this.productCo.length > 0">
            <div class="co-title">全国已服务过
                <span style="color: #0086CC;font-size: 34px;">
                    {{ product.product_co_num }}+
                </span>家企业
            </div>
            <div style="margin-top: 80px">
                <el-row style="margin-left: 80px;" v-for="(row, index) in rows" :key="index" :gutter="10" >
                    <el-col :span="4" v-for="(item, index2) in row" :key="index2">
                        <el-card style="width: 220px;margin-bottom: 15px">
                            <div style="display: flex; align-items: center;">
                                <img :src="item.co_imgUrl" style="width: 50px;height: 50px;;margin-right: 10px;">
                                <div>
                                    <h2 style="display: contents;font-weight: 600;">{{item.co_name}}</h2>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="case-body" v-show="this.productCase.length > 0">
            <div class="case-title">合作案例</div>
            <div class="case-content">
                <el-card class="case-card" v-for="(item, index) in productCase" :key="index">
                    <div>
                        <div class="card-img" style="width: 320px;height: 178px;">
                            <img style="width: 320px;height: 178px;" class="card-img-img" :src="item.case_logo" alt="">
                        </div>
                        <div class="card-content">
                            <div class="card-title">{{ item.case_name }}</div>
                            <div class="card-content-body">{{ item.case_intro }}</div>
                        </div>

                    </div>
                </el-card>
            </div>
        </div>

        <div class="more-case" v-show="this.productCase.length > 0">
            <el-button type="primary" class="more-case-btn" @click="moreCase" round>更多案例</el-button>
        </div>

    </div>
</template>

<script>
export default {
    name: 'productdetail',
    props: {
        activeProduct_id: String,
        objUserInfo: Object
    },
    data() {
        return {
            videoVisible: false,
            product: {},
            imgList: [],
            productCo: [],
            productCase: [],
            rows:[],
        };
    },
    methods: {
        getProductDetail(id) {
            let param = {
                id: id
            }
            this.$server.getProduct(param).then(data => {
                //console.log("data: " + JSON.stringify(data))
                if (data.data.code == 200) {
                    this.product = data.data.data;
                    //this.total = data.data.data.total;
                    this.getProductImg(id);
                    this.getProductCo(id);
                    this.getProductCaseTop3(id);
                }
            })
        },
        getProductImg(id) {
            let param = {
                page: 1,
                pageCount: 99,
                product_id: id
            }
            this.$server.queryProducImgListByEffective(param).then(data => {
                //console.log("data: " + JSON.stringify(data))
                if (data.data.code == 200) {
                    this.imgList = data.data.data.data;
                }
            })
        },
        getProductCo(id) {
            let param = {
                page: 1,
                pageCount: 99,
                product_id: id
            }
            this.$server.queryProducCoListByEffective(param).then(data => {
                //console.log("data: " + JSON.stringify(data))
                if (data.data.code == 200) {
                    this.productCo = data.data.data.data;
                    // 把结果集传到info这个数组
                    const numItems = this.productCo.length;
                    const numRows = Math.ceil(numItems / 6);
                    this.rows = [];
                    for (let i = 0; i < numRows; i++) {
                        const start = i * 6;
                        const end = start + 6;
                        this.rows.push(this.productCo.slice(start, end));
                    }
                    console.log(this.rows);
                }
            })
        },
        getProductCaseTop3(id) {
            let param = {
                pageCount: 3,
                product_id: id
            }
            this.$server.getProductCaseListTop3(param).then(data => {
                //console.log("data: " + JSON.stringify(data))
                if (data.data.code == 200) {
                    this.productCase = data.data.data;
                    //console.log('this.productCase-top3: ' + this.productCase);
                }
            })
        },
        redirectToExternalLink() {
            console.log('objUserInfo: ' + JSON.stringify(this.objUserInfo));
            if (this.objUserInfo !== null && this.objUserInfo !== undefined && Object.keys(this.objUserInfo).length > 0) {
                var url = '';
                if(this.product.product_code != null || this.product.product_code != ''){
                        let detail = {
                            page: this.product.product_site,
                            type: this.product.product_code
                        } 
                        this.$server.getOthorProductRedictPage(detail).then(data => {
                        if (data.data.returnCode == '0') {
                            url = data.data.data;
                            window.open(url, '_blank');
                        }
                    });
                }else {
                    window.open(this.product.product_site, '_blank');
                }
            }else {
                window.open(this.product.product_site, '_blank');
            }
        },
        playVideo() {
            this.videoVisible = true;
        },
        closeVideo() {
            this.videoVisible = false;
        },
        moreCase() {
            //console.log('更多案例');
            var id = this.activeProduct_id;
            var name = this.product.product_name;
            window.location.href = 'product-case-list.html?id=' + id + '&name=' + name;
            //window.location.href = 'productCase.html?id=' + id + '&name=' + name;
        },
    },
    watch: {
        activeProduct_id(newActiveId, oldActiveId) {
            // Handle activeName change
            //console.log('Active Name changed:', newActiveId);
            // You can perform actions based on the new value of activeName
            this.getProductDetail(newActiveId);
        }
    },
    created() {
        this.getProductDetail(this.activeProduct_id);
    }
};
</script>

<style>
.el-tabs__header {
    margin: 0 0 5px;
}
.content {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    margin-top: 65px;
    /* 垂直排列 */
}

.title-body {
    position: absolute;
    z-index: 2;
    top: 180px;
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 54px;
    color: #F6F6F6;
}

.but-body {
    display: flex;
    align-items: center;
    position: absolute;
    z-index: 2;
    top: 580px;

    .el-but1 {
        width: 200px;
        height: 50px;
        font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
        font-weight: 700;
        font-style: normal;
        font-size: 15px;
        margin-right: 15px;
    }

    .el-but2 {
        width: 200px;
        height: 50px;
        font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
        font-weight: 700;
        font-style: normal;
        font-size: 15px;
        Background-color: transparent;
        color: #FFFFFF;
    }
}

.img-body {
    position: relative;
    width: 100%;

    .content-img {
        width: 100%;
        height: 816px;
        /* background-size: contain; */
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        margin-bottom: 10px;
        /* 添加其他样式 */
    }
}

.video-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /* 设置一个较大的 z-index，确保视频显示在最前面 */
    z-index: 9999;
    width: 1000px;

}

.co-body {
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    width: 100%;
}
.co-title {
    font-size: 30px;
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
    font-weight: 700;
    font-style: normal;
    color: #333333;
}

.co-content {
    display: flex;
    margin-top: 50px;
    justify-content: center;
}
.case-body {
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    font-size: 30px;
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
    font-weight: 700;
    font-style: normal;
    color: #333333;

}
.case-content {
        display: flex;
        justify-content: space-around;
        margin-top: 50px;
        width: 1200px;
        flex-wrap: wrap; 
}
.case-card {
            
 }
 .card-img {
    width: 320px;
    height: 178px;
}
.card-img-img {
        width: 320px;
        height: 178px;
}

.card-content {
    width: 320px;
    margin-top: 20px;
}

.card-title {
        font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
        font-weight: 700;
        font-style: normal;
        font-size: 16px;
        color: #333333;
    }

.card-content-body {
    font-family: 'Arial Normal', 'Arial', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    color: #999999;
    text-indent: 2em;
}

.more-case {
    margin-top: 60px;
    margin-bottom: 150px;

    .more-case-btn {
        width: 140px;
        height: 40px;
        background-color: #FFFFFF;
        color: #409EFF;
    }

    .more-case-btn:hover {
        background-color: #409EFF;
        color: #FFFFFF;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/products/components/productdetail.vue